// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");

function name(t) {
  return t.name;
}

function value(t) {
  return t.value;
}

function setValue(t, x) {
  return {
          name: t.name,
          value: x
        };
}

function policyToString(x) {
  if (x === "SinglePageSurvey") {
    return "single_page_survey";
  } else {
    return "multiple_page_survey";
  }
}

function stringToPolicy(x) {
  switch (x) {
    case "single_page_survey" :
        return "SinglePageSurvey";
    default:
      return "MultiplePageSurvey";
  }
}

function displayToValue(label) {
  switch (label) {
    case "Single page survey" :
        return "single_page_survey";
    default:
      return "multiple_page_survey";
  }
}

function valueToDisplay(value) {
  switch (value) {
    case "single_page_survey" :
        return "Single page survey";
    default:
      return "Multiple page survey";
  }
}

function decode(json) {
  return {
          name: Json_decode.field("name", Json_decode.string, json),
          value: stringToPolicy(Json_decode.field("value", Json_decode.string, json))
        };
}

function encode(t) {
  return policyToString(t.value);
}

exports.name = name;
exports.value = value;
exports.policyToString = policyToString;
exports.stringToPolicy = stringToPolicy;
exports.displayToValue = displayToValue;
exports.valueToDisplay = valueToDisplay;
exports.setValue = setValue;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
